__turbopack_context__.v({
  "container": "DlsRZq_container",
  "content": "DlsRZq_content",
  "drawerButton": "DlsRZq_drawerButton",
  "drawerHeader": "DlsRZq_drawerHeader",
  "filterContainer": "DlsRZq_filterContainer",
  "sidebar": "DlsRZq_sidebar",
  "sidebarToggle": "DlsRZq_sidebarToggle",
});
